import React, { useState } from 'react';
import './App.css';

function App() {
  const [showYay, setShowYay] = useState(false);
  const [yesPosition, setYesPosition] = useState({ x: 50, y: 50 });
  const [noPosition, setNoPosition] = useState({ x: 50, y: 70 });

  const handleMouseMove = (e) => {
    // Make Yes button follow cursor at all times
    const x = (e.clientX / window.innerWidth) * 100;
    const y = (e.clientY / window.innerHeight) * 100;
    setYesPosition({ x, y });

    // Check if Yes button (cursor) is close to No button
    const noButton = document.getElementById('no-button');
    if (noButton) {
      const rect = noButton.getBoundingClientRect();
      const noCenterX = rect.left + rect.width / 2;
      const noCenterY = rect.top + rect.height / 2;
      
      const distance = Math.sqrt(
        Math.pow(e.clientX - noCenterX, 2) +
        Math.pow(e.clientY - noCenterY, 2)
      );

      // If Yes button gets within 100px of No button, move No button away
      if (distance < 100) {
        const newX = Math.random() * 80 + 10; // Random position between 10-90%
        const newY = Math.random() * 60 + 20; // Random position between 20-80%
        setNoPosition({ x: newX, y: newY });
      }
    }
  };

  const handleClick = (e) => {
    // Check if click is near the Yes button position (since it follows cursor)
    const yesButton = document.querySelector('.yes-button');
    if (yesButton) {
      const rect = yesButton.getBoundingClientRect();
      const clickX = e.clientX;
      const clickY = e.clientY;
      
      // If click is within Yes button bounds (it should always be since it follows cursor)
      const distance = Math.sqrt(
        Math.pow(clickX - (rect.left + rect.width / 2), 2) +
        Math.pow(clickY - (rect.top + rect.height / 2), 2)
      );
      
      if (distance < 50) { // Within button radius
        setShowYay(true);
      }
    }
  };

  if (showYay) {
    return (
      <div className="yay-container">
        <h1 className="yay-text">YAY! 💕</h1>
        <img 
          src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExcDR0ZnJ3aGN5YzBvZW5qZjBvNWt4Y3NxdGJ3OGt6MnN6cWJ6cWJ6ZCZlcD12MV9naWZzX3NlYXJjaCZjdD1n/MDJ9IbxxvDUQM/giphy.gif"
          alt="Happy celebration"
          className="celebration-gif"
        />
        <p className="sweet-message">thanks bub, i knew it 💖</p>
      </div>
    );
  }

  return (
    <div className="container" onMouseMove={handleMouseMove} onClick={handleClick}>
      <div className="question-box">
        <h1 className="question">
          Katelyn, will you be my Valentine? 💝
        </h1>
        
        <div className="buttons-container">
          <button
            className="yes-button"
            style={{
              position: 'fixed',
              left: `${yesPosition.x}%`,
              top: `${yesPosition.y}%`,
              transform: 'translate(-50%, -50%)',
              pointerEvents: 'none',
            }}
          >
            Yes! 💖
          </button>
          
          <button
            id="no-button"
            className="no-button"
            style={{
              position: 'fixed',
              left: `${noPosition.x}%`,
              top: `${noPosition.y}%`,
              transform: 'translate(-50%, -50%)',
            }}
          >
            No 💔
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
